import Vue from "vue";

import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import SearchBox from "@Scripts/Components/Search/SearchBox.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-searchbox", SearchBox);
    }
}